import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoFixtureIdentity, DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';
import {
  buildPslfFetchMatchers,
  buildPslfMatchers,
} from 'tio-employee/demo/products/pslf-fixtures';

/**
 * Builds the demo matchers + fixtures for the PSLF product. Each scenario maps
 * to a set of request matchers the demo handler serves, so the main-app PSLF
 * dashboard renders demo data through its normal store calls (no route forks).
 * Borrower/employer names derive from the shared fixture identity.
 * @param config selects the PSLF journey
 * @param _scenario the active composite demo scenario
 * @param identity supplies the active borrower and employer
 * @returns fixtures for both request seams
 */
export function buildPslfDemo(
  config: Extract<DemoProductConfig, { kind: 'pslf' }>,
  _scenario: DemoScenario,
  identity: DemoFixtureIdentity
): DemoScenarioResolved {
  return {
    matchers: buildPslfMatchers(config.scenarioId, identity),
    fetchMatchers: buildPslfFetchMatchers(config.scenarioId, identity),
    seed: [],
  };
}
